import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { ScoraCommonModuleComponent } from './scora-common-module.component';
import { ScoraImageViewComponent } from "./scora-image-view/scora-image-view.component";
import { ScoraDocPdfViewComponent } from "./scora-doc-pdf-view/scora-doc-pdf-view.component";
import { ScoraVideoViewComponent } from "./scora-video-view/scora-video-view.component";
import { ScoraAudioViewComponent } from "./scora-audio-view/scora-audio-view.component";
import { ScoraDropdownUiComponent } from "./scora-dropdown-ui/scora-dropdown-ui.component";
import { ScoraNoDataComponent } from "./scora-no-data/scora-no-data.component";
import { ModalModule, PopoverModule } from 'ngx-bootstrap';
import { ScoraModalModuleModule } from "../scora-modal-module/scora-modal-module.module";
import { SearchSuggestionComponent } from "./search-suggestion/search-suggestion.component";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    ScoraModalModuleModule
  ],
  declarations: [
    ScoraCommonModuleComponent,
    ScoraImageViewComponent,
    ScoraDocPdfViewComponent,
    ScoraVideoViewComponent,
    ScoraAudioViewComponent,
    ScoraDropdownUiComponent,
    ScoraNoDataComponent,
    SearchSuggestionComponent
  ],
  exports: [
    ScoraImageViewComponent,
    ScoraDocPdfViewComponent,
    ScoraVideoViewComponent,
    ScoraAudioViewComponent,
    ScoraDropdownUiComponent,
    ScoraNoDataComponent,
    SearchSuggestionComponent
  ]
})
export class ScoraCommonModuleModule { }



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-common-module.module.ts